import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { LoaderIcon } from '../../../components/Icons'
import othersActions from '../../../redux/actions/others'
import { ArrowCalendar } from '../AppointmentSchedule'
import FormBeforeValidation from './FormBeforeValidation'
import FormAfterValidation from './FormAfterValidation'
import { useRegisterForm } from './hook'

const RegisterForm = () => {
  const hookData = useRegisterForm()
  const dispatch = useDispatch()
  const setModalUserData = () => dispatch(othersActions.setModalUserData(true))

  const {
    appointment,
    formikDocument,
    formikRegister,
    user,
    loggedSubmit,
    documentValidation,
    twilioError,
  } = hookData

  const { exist, searched, loading } = documentValidation
  const showAfterValidationForm = searched && !exist

  return (
    <div className='mx-auto max-w-max md:pb-10 lg:pb-0'>
      <div className='mb-4'>
        <Link to="/agenda/" className='flex items-center justify-start gap-2 max-w-max'>
          <ArrowCalendar left color="fill-cyan h-3" />
          <p className='text-md font-bold text-cyan opacity-60'>Volver</p>
        </Link>
        <h1 className='font-bold text-xl sm:text-[28px] xl:text-4xl mt-2'>
          Completá tus <span className='text-cyan'>datos personales</span>:
        </h1>
      </div>

      <div className='flex gap-4 flex-col lg:flex-row w-full'>
        <div className='flex-1 min-w-ful md:max-w-mi lg:min-w-[700px] md:max-w-[700px] space-y-4'>
          <div className='bg-white shadow-2 rounded-lg py-5 px-5 md:px-7'>
            <h4 className='font-bold uppercase text-lg mb-1'>Registro de nuevo usuario</h4>

            {loading ? (
              <LoaderIcon />
            ) : (
              <>
                
                <FormBeforeValidation data={{ formik: formikDocument, ...hookData }} />

                
                {showAfterValidationForm && (
                  <FormAfterValidation data={{ formik: formikRegister, ...hookData }} />
                  
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RegisterForm
